import { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { Line as LineChart } from 'react-chartjs-2';

import LoadingFallback from '~components/LoadingFallback';

import { useReportsVisitsSectionContext } from '../../Context';

import { ReportsVisitsSectionChartsWrapperChart } from '../styles';

import { getPunctualityOfVisitsChartProps } from './utils';

const ReportsVisitsSectionChartsPunctualityOfVisits = (): ReactElement => {
  const {
    data: {
      summary: { data: summaryData, loading: loadingSummaryData },
    },
  } = useReportsVisitsSectionContext();

  return (
    <ReportsVisitsSectionChartsWrapperChart>
      <Typography variant="body1" component="h4" fontWeight="bold">
        Puntualidad de visitas
      </Typography>

      {loadingSummaryData && <LoadingFallback />}

      {!loadingSummaryData && summaryData && (
        <Box maxHeight={302}>
          <LineChart
            {...getPunctualityOfVisitsChartProps(
              summaryData.reportRouteSummaryItemsOnTime,
            )}
          />
        </Box>
      )}
    </ReportsVisitsSectionChartsWrapperChart>
  );
};

export default ReportsVisitsSectionChartsPunctualityOfVisits;
